import { createRootRoute } from '@tanstack/react-router';
import { useAtomValue } from 'jotai/react';
import { useTranslation } from 'react-i18next';

import Loading from '@/components/loading';
import DesktopApp from '@/features/desktop-app';
import WebrtcApp from '@/features/webrtc-app';
import { useMode } from '@/hooks/use-mode';
import { salesforceOpenCtiStatusAtom } from '@/lib/store';

export const Route = createRootRoute({
  component: Root,
});

export function Root() {
  const mode = useMode();
  const openCtiStatus = useAtomValue(salesforceOpenCtiStatusAtom);
  const { t } = useTranslation('salesforce');
  const loadingMessage =
    openCtiStatus === 'reconnecting' ? t('reconnecting') : undefined;

  if (mode === 'loading') return <Loading message={loadingMessage} />;
  if (mode === 'webrtc') return <WebrtcApp />;
  if (mode === 'desktop') return <DesktopApp />;

  return <Loading message={loadingMessage} />;
}
